import * as yup from "yup";
import constantes from "../../catalogos/constantes";
import constantesOperaciones from "../constantes";
const esquemaLlanta = yup.object().shape({
  idCautin: yup
    .string()
    .nullable()
    .notRequired(),

  marcaLlanta: yup
    .mixed()
    .nullable()
    .notRequired(),

  revisarCautin: yup
    .boolean()
    .nullable()
    .notRequired(),

  sinCautinSeleccionado: yup
    .boolean()
    .default(false),

  llantaDanada: yup
    .boolean()
    .default(false),

  tipoLlantaDanada: yup
    .mixed()
    .nullable()
    .when("llantaDanada", {
      is: true,

      then: yup
        .mixed()
        .required(
          "Selecciona el tipo de daño de la llanta",
        ),

      otherwise: yup
        .mixed()
        .nullable()
        .notRequired(),
    }),
});
const esquemaInspeccionOpcional = yup.object().shape({
  necesitaServicio: yup
    .number()
    .nullable()
    .oneOf([-1, 0, 1, 2, null])
    .notRequired(),
});
const salida = yup.object().shape({
  operadorExterno: yup
    .boolean()
    .default(false),

  operador: yup
    .mixed()
    .nullable()
    .when("operadorExterno", {
      is: (operadorExterno) =>
        operadorExterno !== true,

      then: yup
        .mixed()
        .required("Selecciona el operador"),

      otherwise: yup
        .mixed()
        .nullable()
        .notRequired(),
    }),

  nombreOperador: yup
    .string()
    .nullable()
    .when("operadorExterno", {
      is: true,

      then: yup
        .string()
        .nullable()
        .required(
          "Captura el nombre del operador",
        ),

      otherwise: yup
        .string()
        .nullable()
        .notRequired(),
    }),

  vigilante: yup
    .mixed()
    .required("Selecciona el vigilante"),

  patioUbicacion: yup
    .mixed()
    .required("Selecciona la ubicación"),

  odometro: yup
    .mixed()
    .required("Captura el odómetro"),

  verificacionPlacasUnidad: yup
    .mixed()
    .when("esPermisionario", {
      is: true,

      then: yup
        .mixed()
        .notRequired(),

      otherwise: yup
        .mixed()
        .required(
          "Indica si las placas de la unidad son correctas",
        ),
    }),

  verificacionPlacas: yup
    .mixed()
    .when("esPermisionario", {
      is: true,

      then: yup
        .mixed()
        .notRequired(),

      otherwise: yup
        .mixed()
        .required(
          "Indica si las placas del remolque son correctas",
        ),
    }),

verificacionSelloFiscal: yup
  .mixed()
  .nullable()
  .when(["conCaja", "unidadCargada"], {
    is: (conCaja, unidadCargada) =>
      conCaja === true &&
      unidadCargada !== false,

    then: yup
      .boolean()
      .nullable()
      .required(
        "Indica si el sello fiscal es correcto",
      ),

    otherwise: yup
      .mixed()
      .nullable()
      .notRequired(),
  }),
  estadoSelloFiscal: yup
    .string()
    .nullable()
.when(
  [
    "conCaja",
    "unidadCargada",
    "verificacionSelloFiscal",
  ],
  {
    is: (
      conCaja,
      unidadCargada,
      verificacionSelloFiscal,
    ) =>
      conCaja === true &&
      unidadCargada !== false &&
      verificacionSelloFiscal === false,

        then: yup
          .string()
          .nullable()
          .oneOf(
            ["nuevo", "danado", "otro"],
            "Selecciona un estado válido",
          )
          .required(
            "Selecciona el estado del sello fiscal",
          ),

        otherwise: yup
          .string()
          .nullable()
          .notRequired(),
      },
    ),

  selloFiscalNuevo: yup
    .string()
    .nullable()
.when(
  [
    "conCaja",
    "unidadCargada",
    "verificacionSelloFiscal",
    "estadoSelloFiscal",
  ],
  {
    is: (
      conCaja,
      unidadCargada,
      verificacionSelloFiscal,
      estadoSelloFiscal,
    ) =>
      conCaja === true &&
      unidadCargada !== false &&
      (
        verificacionSelloFiscal === true ||
        (
          verificacionSelloFiscal === false &&
          Boolean(estadoSelloFiscal)
        )
      ),

        then: yup
          .string()
          .nullable()
          .required(
            "Captura el sello fiscal",
          ),

        otherwise: yup
          .string()
          .nullable()
          .notRequired(),
      },
    ),

  nombreUnidad: yup
    .mixed()
    .when("esPermisionario", {
      is: true,

      then: yup
        .mixed()
        .required(
          "Captura la unidad permisionaria",
        ),

      otherwise: yup
        .mixed()
        .nullable()
        .notRequired(),
    }),

  nombreCaja: yup
    .mixed()
    .when(
      ["esExterno", "conCaja"],
      {
        is: (esExterno, conCaja) =>
          esExterno === true &&
          conCaja === true,

        then: yup
          .mixed()
          .required(
            "Captura el número del remolque",
          ),

        otherwise: yup
          .mixed()
          .nullable()
          .notRequired(),
      },
    ),

  unidad: yup
    .mixed()
    .when(
      ["esPermisionario", "id"],
      {
        is: (esPermisionario, id) =>
          esPermisionario === false &&
          id === 0,

        then: yup
          .mixed()
          .required(
            "Selecciona la unidad",
          ),

        otherwise: yup
          .mixed()
          .nullable()
          .notRequired(),
      },
    ),

  caja: yup
    .mixed()
    .when(
      [
        "conCaja",
        "id",
        "esExterno",
      ],
      {
        is: (
          conCaja,
          id,
          esExterno,
        ) =>
          conCaja === true &&
          id === 0 &&
          esExterno === false,

        then: yup
          .mixed()
          .required(
            "Selecciona el remolque",
          ),

        otherwise: yup
          .mixed()
          .nullable()
          .notRequired(),
      },
    ),

origen: yup
  .string()
  .nullable()
  .when("tipo", {
    is: (tipo) =>
      Number(tipo) !==
      constantesOperaciones.tipoControlPatios.salida,

    then: yup
      .string()
      .nullable()
      .trim()
      .required("Captura el origen"),

    otherwise: yup
      .string()
      .nullable()
      .notRequired(),
  }),

  tamanioRemolque: yup
    .mixed()
    .when(["conCaja", "id"], {
      is: (conCaja, id) =>
        conCaja === true &&
        id === 0,

      then: yup
        .number()
        .required(
          "Selecciona el tamaño del remolque",
        )
        .min(
          1,
          "Selecciona el tamaño del remolque",
        ),

      otherwise: yup
        .mixed()
        .nullable()
        .notRequired(),
    }),

  medidasInternas: yup
    .mixed()
    .when(["conCaja", "id"], {
      is: (conCaja, id) =>
        conCaja === true &&
        id === 0,

      then: yup.object().shape({
        alto: yup
          .number()
          .required("Captura el alto interno")
          .min(1),

        ancho: yup
          .number()
          .required("Captura el ancho interno")
          .min(1),

        largo: yup
          .number()
          .required("Captura el largo interno")
          .min(1),
      }),

      otherwise: yup
        .mixed()
        .nullable()
        .notRequired(),
    }),

  medidasExternas: yup
    .mixed()
    .when(["conCaja", "id"], {
      is: (conCaja, id) =>
        conCaja === true &&
        id === 0,

      then: yup.object().shape({
        alto: yup
          .number()
          .required("Captura el alto externo")
          .min(1),

        ancho: yup
          .number()
          .required("Captura el ancho externo")
          .min(1),

        largo: yup
          .number()
          .required("Captura el largo externo")
          .min(1),
      }),

      otherwise: yup
        .mixed()
        .nullable()
        .notRequired(),
    }),

  inspeccionCabina: yup
    .array()
    .of(esquemaInspeccionOpcional)
    .nullable()
    .notRequired(),

inspeccionUnidad: yup
  .mixed()
  .when("unidad", {
    is: (unidad) =>
      Number(unidad?.tipoUnidadId) ===
      constantes.tiposUnidad.Utilitario,

    then: yup
      .array()
      .nullable()
      .notRequired(),

    otherwise: yup
      .array()
      .of(
        yup.object().shape({
          necesitaServicio: yup
            .number()
            .min(0)
            .required(
              "Selecciona el resultado de la inspección",
            ),
        }),
      ),
  }),
inspeccionRemolque: yup
  .mixed()
  .when("conCaja", {
    is: true,

    then: yup
      .array()
      .of(
        yup.object().shape({
          necesitaServicio: yup
            .number()
            .oneOf(
              [0, 1, 2],
              "Selecciona el resultado de la inspección",
            )
            .required(
              "Selecciona el resultado de la inspección",
            ),
        }),
      )
      .required(),

    otherwise: yup
      .mixed()
      .nullable()
      .notRequired(),
  }),

  llantasUnidad: yup
    .array()
    .of(esquemaLlanta),

  llantasRemolque: yup
    .array()
    .when("conCaja", {
      is: true,

      then: yup
        .array()
        .of(esquemaLlanta),

      otherwise: yup
        .array()
        .nullable()
        .notRequired(),
    }),

  checkList: yup
    .array()
    .of(
      yup.object().shape({
        checkList: yup
          .array()
          .of(
            yup.object().shape({
              comentarios: yup
                .mixed()
                .when(
                  [
                    "esIncidencia",
                    "puntoInspeccion.id",
                  ],
                  {
                    is: (
                      esIncidencia,
                    ) =>
                      esIncidencia === true,

                    then: yup
                      .string()
                      .required(
                        "Captura los comentarios",
                      ),

                    otherwise: yup
                      .mixed()
                      .nullable()
                      .notRequired(),
                  },
                ),

              fotoActual: yup
                .mixed()
                .when(
                  "puntoInspeccion.id",
                  {
                    is: (puntoId) =>
                      Boolean(puntoId),

                    then: yup
                      .mixed()
                      .required(
                        "Captura la fotografía",
                      ),

                    otherwise: yup
                      .mixed()
                      .nullable()
                      .notRequired(),
                  },
                ),
            }),
          ),
      }),
    ),
});

const checkList = yup.object().shape({
  checkList: yup
    .array()
    .of(
      yup.object().shape({
        checkList: yup
          .array()
          .of(
            yup.object().shape({
              comentarios: yup
                .mixed()
                .when(
                  [
                    "esIncidencia",
                    "puntoInspeccion.id",
                  ],
                  {
                    is: (
                      esIncidencia,
                    ) =>
                      esIncidencia === true,

                    then: yup
                      .string()
                      .required(
                        "Captura los comentarios",
                      ),

                    otherwise: yup
                      .mixed()
                      .nullable()
                      .notRequired(),
                  },
                ),

              fotoActual: yup
                .mixed()
                .when(
                  "puntoInspeccion.id",
                  {
                    is: (puntoId) =>
                      Boolean(puntoId),

                    then: yup
                      .mixed()
                      .required(
                        "Captura la fotografía",
                      ),

                    otherwise: yup
                      .mixed()
                      .nullable()
                      .notRequired(),
                  },
                ),
            }),
          ),
      }),
    ),
});

const salidasValidacionEsquema = {
  salida,
  checkList,
};

export default salidasValidacionEsquema;